import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {TeamModel} from '../../../models/api/teamModel';
import {ThunkAction} from '../../appThunk';

/*
 * Action types.
 */

export enum TeamsActionsEnum {
  TEAM_UPDATED = '@@data/teams/TEAM_UPDATED',
  TEAM_DELETED = '@@data/teams/TEAM_DELETED',
}

/*
 * Types.
 */

export interface TeamUpdatedAction extends ActionWithPayload<TeamModel> {
  type: TeamsActionsEnum.TEAM_UPDATED;
}

export interface TeamDeletedAction extends ActionWithPayload<number> {
  type: TeamsActionsEnum.TEAM_DELETED;
}

/*
 * Action creators.
 */

export function updateTeam(newTeam: TeamModel): ThunkAction {
  return (dispatch, getState) => {
    // Find the existing team.
    const existingTeam = getState().data.teams[newTeam.id];

    // No need to do anything if the new team is older.
    if (existingTeam && existingTeam.updatedAt > newTeam.updatedAt) {
      return null;
    }

    const action: TeamUpdatedAction = {
      type: TeamsActionsEnum.TEAM_UPDATED,
      payload: {...existingTeam, ...newTeam},
    };
    return dispatch(action);
  };
}

export function deleteTeam(teamId: number): ThunkAction {
  return (dispatch, getState) => {
    // If we don't have this team, nothing to do.
    const existingTeam = getState().data.teams[teamId];
    if (!existingTeam) {
      return null;
    }

    const action: TeamDeletedAction = {
      type: TeamsActionsEnum.TEAM_DELETED,
      payload: teamId,
    };
    return dispatch(action);
  };
}

/*
 * Union type.
 */

export type TeamsAction = TeamUpdatedAction | TeamDeletedAction;
